import React from 'react'

export const notFoundPage = () => {
  return (
    <div className='ui-not-found-page'>Not Found Page</div>
  )
}

// set display name
notFoundPage.displayName = 'notFoundPage';

// set default props
notFoundPage.defaultProps = {};
